<template>
  <div class="container text-center">
    <br/>
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-lg-6">
        <img src="/img/logo.svg" :alt="$t('main-logo-title-alt')" class="img-responsive mb-4">
      </div>
    </div>

    <h1>
      {{ $t('page-not-found') }}
    </h1>

    <NuxtLink to="/" :title="$t('back-to-home-page')">
      <h2>{{ $t('back-to-home-page') }}</h2>
    </NuxtLink>

  </div>
</template>


<script lang="ts" setup>

import { onMounted, ref} from "vue";
import {useState, useHead, useNuxtApp} from "#app";

const {$i18n} = useNuxtApp();

onMounted(() => {
  useState('first_preload', () => false).value = false;
})


useHead({
  title: `404 ${$i18n.t('page-not-found')}`,
  bodyAttrs: {
    class: '__admin'
  },
  meta: [
    {
      hid: "robots", name: "robots",
      content: "noindex"
    }
  ]
})


</script>
